import React from 'react';
import { isSafari } from 'react-device-detect';
import { Platform, useWindowDimensions } from 'react-native';
import styled from 'styled-components/native';
import CompareChart from '../../components/charts/CompareChart';
import Colors from '../../constants/Colors';

const sampleData = [
  { x: -2, y: 0 },
  { x: -1.8, y: 0.5 },
  { x: -1.6, y: 0.6 },
  { x: -1.4, y: 1 },
  { x: -1.2, y: 2 },
  { x: -1.0, y: 3 },
  { x: -0.8, y: 4 },
  { x: -0.6, y: 6 },
  { x: -0.4, y: 10 },
  { x: -0.2, y: 15 },
  { x: 0, y: 23 },
  { x: 0.2, y: 29 },
  { x: 0.4, y: 33 },
  { x: 0.6, y: 34 },
  { x: 0.8, y: 33 },
  { x: 1, y: 29 },
  { x: 1.2, y: 23 },
  { x: 1.4, y: 15 },
  { x: 1.6, y: 10 },
  { x: 1.8, y: 6 },
  { x: 2, y: 4 },
  { x: 2.2, y: 3 },
  { x: 2.4, y: 1.5 },
  { x: 2.6, y: 0.9 },
  { x: 2.8, y: 0.5 },
  { x: 3, y: 0 }
];

const StyledView = styled.View<{
  isDesktop: boolean;
}>`
  background: ${Colors.background};
  height: 100%;
  padding-top: 64px;
  align-items: center;
  ${isSafari ? 'width: 85%' : 'width: 100%'}
`;

const CompareChartScreen: React.FC = () => {
  const window = useWindowDimensions();
  const isDesktop = window.width >= 768;
  return (
    <StyledView isDesktop={isDesktop}>
      <CompareChart
        intervention='Dreem Capsule'
        subject='Sleep'
        study='Sleep duration'
        xAxisValueUnits='HRS'
        data={sampleData}
        position={1.2}
        xAxisMinValueLabel={-2}
        xAxisMaxValueLabel={3}
        yAxisMaxValueLabel={40}
      />
    </StyledView>
  );
};

export default CompareChartScreen;
